import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutTrailerTypeXref extends Layout {
    buttonExpand: Button;
    horizontalspacerForTrailerType: HorizontalSpacer;
    labelCrossRef: Label;
    panelCollapsible: Panel;
    panelHeader: Panel;
    panelTrailerType: Panel;
    panelTrailerTypeButtons: Panel;
    sourceEdiCrossRefTrailerType: DataSource;
    tableCrossRef: Table;
}
